import React from "react";
import RightImages from "../Components/RightImages/RightImages";
import LAD from "../Components/Vessels/LAD/LAD";
import LCX from "../Components/Vessels/LCX/LCX";
import RCA from "../Components/Vessels/RCA/RCA";
import ResultChart from "../Components/ResultChart/ResultChart";
import Scene from "../Components/Three/Scene";
import { useSelector } from "react-redux";
import LeftNav from "../Components/LeftNav/LeftNav";
import Handler from "../Components/Three/ColorfFind/handler";

function Home() {
    const activeVessel = useSelector(item => item.flowviewer.activeVessel);
    const files = useSelector(item => item.flowviewer.files);
    const uploadedVessels = useSelector(item => item.flowviewer.uploadedVessels);
    const activeVesselFFR = uploadedVessels[activeVessel]?.ffr;

    const printCamera = useSelector(item => item.flowviewer.printCamera);

    function getVesselMap(vessel) {
        switch (vessel) {
            case "lad":
                return <LAD cls={"home-lad"} />
            case "rca":
                return <RCA cls={"home-lad"} />
            case "lcx":
                return <LCX cls={"home-lad"} />
            default:
                return "";
        }
    }

    return (
        <div className="d-flex align-items-start">
            <Handler />
            <div className="wrap-left">
                <LeftNav />
            </div>
            <div className="d-grid w-100">
                <div className="rows">
                    <div className="cols">
                        <RightImages />
                    </div>
                    <div className="cols-np bg-white cols-np-border">
                        <div className="slider">
                            {getVesselMap(activeVessel)}
                        </div>
                    </div>
                </div>
                <div className="rows">
                    <div className="cols">
                        {
                            activeVessel &&
                            activeVesselFFR &&
                            <ResultChart />
                        }
                    </div>
                    <div className="cols-np">
                        {
                            activeVessel &&
                            files["stl"] &&
                            files["coloring"] &&
                            <Scene thisId={3}
                                classes={"once-scene"}
                                clearColor={"black"}
                                legends={"FFR"}
                                maps={"rainbowInvert"}
                                orbit={true}
                                coord={printCamera[activeVessel]}
                                help={false}
                            />
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Home;